export default __webpack_public_path__ + "cf128491df22b0d1f1f1a20b9fe2eda0.svg";